import { PageScaffold } from "../../shared/ui/PageScaffold";

const adminLinks = [
  { to: "/t/:tenantSlug/teacher/admin", label: "管理ホーム" },
  { to: "/t/:tenantSlug/teacher/admin/lessons", label: "レッスン一覧" }
];

export function AdminLessonDetailPage() {
  return (
    <PageScaffold
      title="Admin Lesson Detail"
      description="レッスン詳細画面のプレースホルダーです。"
      links={adminLinks}
    >
      <p>ここに lesson 詳細を表示します。</p>
    </PageScaffold>
  );
}
